import { render, staticRenderFns } from "./InventoryQrForm.vue?vue&type=template&id=4817c247&scoped=true&"
import script from "./InventoryQrForm.vue?vue&type=script&lang=js&"
export * from "./InventoryQrForm.vue?vue&type=script&lang=js&"
import style0 from "./InventoryQrForm.vue?vue&type=style&index=0&id=4817c247&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4817c247",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VChip,VCol,VContainer,VFileInput,VImg,VRow,VTextField})
